export function hasRenderableSpectrumValues(value: unknown): boolean {
    return Array.isArray(value) && value.some((item) => Number.isFinite(item) && Number(item) > 0);
}

type SimplifiedSpectrumProfile = {
    models: string[];
    indexes: number[];
};

// Models that only publish a subset of the shared 1/3-octave spectrum slots.
// Add future limited-spectrum devices here instead of branching in chart code.
const SIMPLIFIED_SPECTRUM_PROFILES: SimplifiedSpectrumProfile[] = [
    {
        models: ["LF010"],
        // CESVA LF010 only publishes the 1/3-octave bands from 50 Hz to 5 kHz.
        indexes: [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24],
    },
];

export function getSpectrumIndexesForDevice(model: string | undefined, totalLength: number): number[] {
    const normalizedModel = model?.toUpperCase();
    const simplifiedProfile = SIMPLIFIED_SPECTRUM_PROFILES.find((profile) => profile.models.includes(normalizedModel ?? ""));

    if (simplifiedProfile) {
        return simplifiedProfile.indexes.filter((index) => index < totalLength);
    }

    return Array.from({ length: totalLength }, (_, index) => index);
}

export function getRenderableSpectrumIndexes(
    model: string | undefined,
    values: Array<unknown> | null | undefined,
    totalLength: number,
): number[] {
    const deviceIndexes = getSpectrumIndexesForDevice(model, totalLength);
    const valueArray = Array.isArray(values) ? values : [];

    return deviceIndexes.filter((index) => {
        if (index < 31) {
            return true;
        }

        return Number.isFinite(valueArray[index]) && Number(valueArray[index]) > 0;
    });
}

export function selectSpectrumCategories(categories: string[], indexes: number[]): string[] {
    return indexes.map((index) => categories[index]).filter((category): category is string => !!category);
}

export function selectSpectrumSeries<T>(values: Array<T | null | undefined>, indexes: number[]): T[] {
    return indexes.map((index) => values[index]).filter((value): value is T => value !== null && value !== undefined);
}
